import { IEmoji } from '@getaccept/lib-ui';

export const EMOJI_INLINE_TRIGGER_COUNT = 3;

export const EMOJI_KEY = new RegExp('([^:]+)?(:[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?)', 'g');
export const EMOJI_SEARCH_KEY = new RegExp('(:[a-zA-Z0-9-_+]+(:skin-tone-[2-6]:)?)', 'g');

export const CUSTOM_EMOJI_LIST: IEmoji[] = [
  // {
  //   name: 'GetAccept',
  //   short_names: ['getaccept'],
  //   text: '',
  //   emoticons: [],
  //   custom: true,
  //   keywords: ['ga', 'getaccept'],
  //   imageUrl: '/assets/img/favicon.png',
  // },
];
